import { LoadingButton } from "@mui/lab";
import { Card, CardActions, CardContent, CardHeader, Divider, Grid, InputAdornment, Typography } from "@mui/material";
import { NumberTextField } from "modules/common";
import { useTranslation } from "react-i18next";

export default function PricesCard({ settings, handleChange, loading, error, isSuccess, onConfirm }) {
    const { t } = useTranslation()
    const onConfirmHandler = () => {
        onConfirm({
            deliveryPrice: Number(settings?.deliveryPrice),
            shieldPrice: Number(settings?.shieldPrice),
            hyperPrice: Number(settings?.hyperPrice),
            hyperPlusPrice: Number(settings?.hyperPlusPrice),
            redBoxDeliveryPrice: Number(settings?.redBoxDeliveryPrice)
        })
    }
    return (
        <Card sx={{ mt: 20 }}>
            <CardHeader title={t("Edit prices")} />
            <Divider />
            <CardContent>
                <Grid container spacing={20}>
                    <Grid item md={6} sm={6} xs={12}>
                        <NumberTextField
                            InputProps={{
                                endAdornment: <InputAdornment position="end">{t("Riyal")}</InputAdornment>,
                            }}
                            name="deliveryPrice"
                            label={t("Delivery price")}
                            value={settings?.deliveryPrice ?? ''}
                            onChange={handleChange}
                            fullWidth
                            size="small"
                        />
                    </Grid>
                    <Grid item md={6} sm={6} xs={12}>
                        <NumberTextField
                            InputProps={{
                                endAdornment: <InputAdornment position="end">{t("Riyal")}</InputAdornment>,
                            }}
                            name="shieldPrice"
                            label={t("Shield price")}
                            value={settings?.shieldPrice ?? ''}
                            onChange={handleChange}
                            fullWidth
                            size="small"
                        />
                    </Grid>
                    <Grid item md={6} sm={6} xs={12}>
                        <NumberTextField
                            InputProps={{
                                endAdornment: <InputAdornment position="end">{t("Riyal")}</InputAdornment>,
                            }}
                            name="hyperPrice"
                            label={t("Hyper price")}
                            value={settings?.hyperPrice ?? ''}
                            onChange={handleChange}
                            fullWidth
                            size="small"
                        />
                    </Grid>
                    <Grid item md={6} sm={6} xs={12}>
                        <NumberTextField
                            InputProps={{
                                endAdornment: <InputAdornment position="end">{t("Riyal")}</InputAdornment>,
                            }}
                            name="hyperPlusPrice"
                            label={t("Hyper plus price")}
                            value={settings?.hyperPlusPrice ?? ''}
                            onChange={handleChange}
                            fullWidth
                            size="small"
                        />
                    </Grid>
                    <Grid item md={6} sm={6} xs={12}>
                        <NumberTextField
                            InputProps={{
                                endAdornment: <InputAdornment position="end">{t("Riyal")}</InputAdornment>,
                            }}
                            name="redBoxDeliveryPrice"
                            label={t("Red Box price")}
                            value={settings?.redBoxDeliveryPrice ?? ''}
                            onChange={handleChange}
                            fullWidth
                            size="small"
                        />
                    </Grid>
                </Grid>
            </CardContent>
            <Divider />
            <CardActions sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row-reverse' }}>
                <LoadingButton sx={{ textTransform: "none" }} variant="contained" loading={loading} onClick={onConfirmHandler}>{t("Confirm")}</LoadingButton>
                {isSuccess && <Typography color="success.main">{t("Done successfully")}</Typography>}
                {!!error && <Typography color="error">{t(error)}</Typography>}
            </CardActions>
        </Card>
    )
}
